import React from "react";
import ContractorListItem from "../../components/contractor/ContractorList/ContractorListItem";
import {Box} from "@mui/material";
import {useParams} from "react-router";
import {useTitle} from 'react-use';
import { t } from "@lingui/core/macro";

const ContractorListPage = ()  => {

    useTitle(t`List Contractor`);
    
    const allQueries = useParams()
    const query = Object.fromEntries(
        Object.entries(allQueries).filter(([key]) => key.endsWith("Id"))
    )
    
    return (
        <Box>
            <ContractorListItem showAdd={true} {...query} />
        </Box>
    )
}

export default ContractorListPage;
